import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../utils/types/api-response";
import {
    IEditSessionTime,
    ITerminateIntakeAppointmentPayload,
    ProviderCaseloadApp,
} from "../types/schedule.types";
import {
    editSessionTime,
    terminateIntakeAppointment,
} from "../services/schedule.services";

export function useEditSessionTime(sessionHistoryId: string) {
    return useMutation<
        IApiResponse<ProviderCaseloadApp>,
        AxiosError<IApiResponse<ProviderCaseloadApp>>,
        IEditSessionTime
    >({
        mutationKey: ["edit-session-time"],
        mutationFn: (data: IEditSessionTime) =>
            editSessionTime(data, sessionHistoryId),
    });
}

export function useTerminateIntakeAppointment() {
    return useMutation<
        IApiResponse<null>,
        AxiosError<IApiResponse<null>>,
        ITerminateIntakeAppointmentPayload
    >({
        mutationKey: ["terminate-intake-appointment"],
        mutationFn: ({
            intakeClientId,
            externalSessionId,
            payload,
        }: ITerminateIntakeAppointmentPayload) =>
            terminateIntakeAppointment(
                intakeClientId,
                externalSessionId,
                payload
            ),
    });
}
